module.exports = __webpack_public_path__ + "img/footer-slogan-geo.96047dbc.svg";